import { Injectable } from '@angular/core'
import { ConnectionService } from '@app-services/connection/connection.service'
import { TabletIdentifierService } from '@app-services/tablet-identifier/tablet-identifier.service'
import { TabletsService } from '@app-services/tablets/tablets.service'

@Injectable({
    providedIn: 'root',
})
export class BootService {

    constructor(
        private tabletIdentifierService: TabletIdentifierService,
        private tabletsService: TabletsService,
        private connectionService: ConnectionService,
    ) {
    }

    public async initialize() {
        // WARNING: AVOID INITIALIZING SERVICES HERE THAT DEPEND ON APOLLO/CODEGEN SERVICES,
        // AS IT MAY NOT BE FULLY CONFIGURED AND READY YET.

        return Promise.all([
            this.connectionService.initialize(),
            this.tabletIdentifierService.initialize(),
            this.tabletsService.initialize(),
        ])
    }
}
